import React from 'react';
import Checkbox from'./Checkbox';
import TextField from './Textfield';
import Button from './Button';
import { Link } from 'react-router-dom'
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment'
import config from "./../../config";
import "./EdiTable.css";
import {utcToZonedTime} from "date-fns-tz";
const { zonedTimeToUtc, format} = require('date-fns-tz')

var cx = require('classnames');
var imm = require('immutable');
var RandExp = require('randexp');


class TableHead extends React.Component {
    onPageChange(i) {
        this.props.onPageChange(i)
    }
    render() {
        var cols = this.props.columns.length;
        return (
            <thead className="bg-light">
                <tr>
                    {
                        this.props.columns.map(function(cols, i) {
                            if (cols.visible === false) {
                                return;
                            }
                            return <th key={i}>{cols.label}</th>
                        })
                    }
                </tr>
            </thead>
        );
    }
}

class ButtonDelete extends React.Component {
    onDelete(val) {
        this.props.onDelete(val);
    }
    handleDelete(data) {
        if(window.confirm("Are you sure?")) {
            if(this.props.pk == undefined) {
                return; 
            } else {
                this.props.childProps.dataProvider.delete(this.props.url, {
                    id: this.props.pk
                }, this.props)
                .then(response => {
                    toast.success('Entry Deleted Successfully', {})
                    this.onDelete(this.props.pk)
                }).catch(
                    (err)=> {
                        toast.error(this.errorMessage(err.message), {})
                        var result = err.message;
                        let flds = []
                        if (result !== undefined && result.fields !== undefined) {
                            flds = result.fields;
                        }
                        this.setState({
                            errorfields: flds
                        });           
                })
            }
        }
    }
    errorMessage(message) {
        if (message === undefined) {
            return "Backend Error";
        }
        let errstr = message.msg;
        errstr = (errstr === undefined) ? "Backend Error": errstr;
        for (let i in message.fields) {
            var fieldname = message.fields[i];
            this.props.metadata.map(function (mrow, mindex) {
                if (mrow.source === fieldname) {
                    errstr = errstr.replace(/%s/gi, mrow.label);
                }
            }, this);
        }
        return errstr;
    }
    render() {
        return (
            <Button bsStyle='danger btn-xs' onClick={this.handleDelete.bind(this)} value="Delete" icon="delete"/>
        )
    }
}

class ButtonEdit extends React.Component {
    handleEdit(data) {
        this.props.onEdit(data);
    }
    render() {
        return (
            <Button bsStyle='warning  btn-xs' onClick={this.handleEdit.bind(this)} value="Edit" icon="edit"/>
        )
    }
}

class ButtonSave extends React.Component {
    handleSave(data) {
        this.props.onSave(data);
    }
    render() {
        return (
            <Button bsStyle='success btn-xs' onClick={this.handleSave.bind(this)} value="Save" icon="save"/>
        )
    }
}

class ButtonCancel extends React.Component {
    handleCancel(data) {
        this.props.onCancel(data);
    }
    render() {
        return (
            <Button bsStyle='white btn-xs' onClick={this.handleCancel.bind(this)} value="Cancel" icon="cancel"/>
        )
    }
}

class TableRow extends React.Component {
    constructor (props) {
        super(props)
        var initdata = imm.Map();
        this.props.metadata.map(function (col, key) {
            initdata = initdata.set(col.source, this.props.row[col.source]);
        }, this);
        this.state = {
            edit: false,
            data: initdata,
            backupdata: initdata
        }
    }
    componentDidMount() {

    }  
    onUpdate(val){
        this.props.onUpdate(val);
    }
    onDelete(val) {
        this.props.onDelete(val);
    }
    onEdit(val) {
        this.setState({edit: true});
    }
    onSave(val) {
        this.setState({errorfields: [], errormsg: ''});
        var data = this.state.data.toJS();
        this.props.childProps.dataProvider.update(this.props.url, {
            id: this.props.id,
            data: data,
            previousData: data
        }, this.props)
        .then(response => {
            toast.success('Entry Updated Successfully', {})
            this.setState({
                    data: imm.Map(data),
                    backupdata: imm.Map(data),
                    edit: false
                })
        }).catch(
            (err)=> {
                toast.error(this.errorMessage(err.message), {})
                var result = err.message;
                let flds = []
                if (result !== undefined && result.fields !== undefined) {
                    flds = result.fields;
                }
                this.setState({
                    errorfields: flds
                });           
        })
    }
    onCancel(val) {
        this.setState({
            edit: false,
            data: this.state.backupdata
        });
    }
    handleChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }));
    }
    handleSelectChange(key, value) {
        if (value === null) {
            return;
        }
        var val = value.value;
        this.setState((state) => ({
            data: state.data.set(key, val)
        }));
    }
    handleMultiSelectChange(key, value) {
        if (value === null) {
            this.setState((state) => ({
                data: state.data.set(key, "")
            }));
        } else {
            let newvals = ""
            for (var i = 0; i < value.length; i++) {
                newvals = newvals.concat(",", value[i].value)
            }
            this.setState((state) => ({
                data: state.data.set(key, newvals)
            }));
        }
    }
    handleDateChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }));
    }
    errorMessage(message) {
        if (message === undefined) {
            return "Backend Error"
        }
        let errstr = message.msg;
        errstr = (errstr === undefined) ? "Backend Error": errstr;
        for (let i in message.fields) {
            var fieldname = message.fields[i];
            this.props.metadata.map(function (mrow, mindex) {
                if (mrow.source === fieldname) {
                    errstr = errstr.replace(/%s/gi, mrow.label);
                }
            }, this);
        }
        return errstr;
    }
    render() {
        var pk = this.props.id;
        var row_editable = true;
        if (this.props.row.row_editable !== undefined && this.props.row.row_editable === 0) {
            row_editable = false;
        }
        const {prefs} = this.props;
        return (            
            <tr pk={pk}>
                {this.props.metadata.map(function(col, index) {

                    if (col.type === undefined) {
                        var ctype = col.type_edit;
                    } else {
                        var ctype = col.type;
                    }

                    if (ctype === 'primary') {
                        pk = this.props.row[col.source];
                    }
                    var meta = {};
                    if (this.props.remotemeta === undefined) {
                        meta = {};
                    } else {
                        meta = this.props.remotemeta[col.source];
                        if (meta === undefined) {
                            meta = {};
                        }
                    }
                    // buttons
                    if (ctype === 'action_buttons') {
                        if (!row_editable) {
                            return null;
                        } else if (!this.state.edit) {
                            return (
                                <td key={index}>
                                    <ButtonEdit
                                        index={index}
                                        pk={pk}
                                        onEdit={this.onEdit.bind(this)}/>
                                    <ButtonDelete
                                        index={index}
                                        pk={pk}
                                        url={this.props.url}
                                        urlattrs={this.props.urlattrs}
                                        onDelete={this.onDelete.bind(this)}
                                        childProps={this.props.childProps}/>
                                        
                                </td>)
                        } else {
                            return (
                                <td key={index}>
                                    <ButtonSave
                                        index={index}
                                        pk={pk}
                                        url={this.props.url}
                                        urlattrs={this.props.urlattrs}
                                        onSave={this.onSave.bind(this)}/>
                                    <ButtonCancel
                                        index={index}
                                        pk={pk}
                                        onCancel={this.onCancel.bind(this)}/>
                                </td>)
                        }
                    }
                    // invisible columns
                    if (col.visible === false) {
                        return;
                    }
                    // SELECTs
                    if (ctype === 'select') {
                        if (!this.state.edit || !col.editable) {
                            var key = this.state.data.get(col.source);
                            if (meta.values === undefined) {
                                return <td key={index}>No Data</td>
                            } else {
                                return <td key={index}>{meta.values[key]}</td>
                            }
                        } else {
                            //TODO: fix valuesif cases
                            var options = [];
                            var defaultSelect = {value: 0, label: '--'};
                            Object.keys(meta.values).map(function(i) {
                                options.push({value: i, label: meta.values[i]});
                                if (i === this.state.data.get(col.source)) {
                                    defaultSelect = {value: i, label: meta.values[i]}
                                }
                            }, this);
                            return  (
                                <td key={index}>
                                    <Select
                                        name={col.source}
                                        options={options}
                                        selected={this.props.row[col.source]}
                                        id={col.source}
                                        placeholder={col.label}
                                        value={defaultSelect}
                                        onChange={this.handleSelectChange.bind(this, col.source)}
                                    />
                                </td>
                            )
                        }
                    }
                    // ENUMs are Selects but with colored labels
                    if (ctype === 'enum') {
                        if (!this.state.edit || !col.editable) {
                            var key = this.state.data.get(col.source);
                            if (meta.values === undefined) {
                                return <td key={index}>No Data</td>
                            } else {
                                return <td key={index}>
                                    <div className= { cx('label','label-info','lb-sm', col.classnames[this.props.row[col.source]] )}>
                                        {meta.values[key]}
                                    </div>
                                </td>
                            }
                        } else {
                            //TODO: fix valuesif cases
                            var options = [];
                            var defaultSelect = {value: 0, label: '--'};
                            Object.keys(meta.values).map(function(i) {
                                options.push({value: i, label: meta.values[i]});
                                if (i === this.state.data.get(col.source)) {
                                    defaultSelect = {value: i, label: meta.values[i]}
                                }
                            }, this);
                            return  (
                                <td key={index}>
                                    <Select
                                        name={col.source}
                                        options={options}
                                        selected={this.props.row[col.source]}
                                        id={col.source}
                                        placeholder={col.label}
                                        value={defaultSelect}
                                        onChange={this.handleSelectChange.bind(this, col.source)}
                                    />
                                </td>
                            )
                        }
                    }
                    // MULTISELECTS
                    if (ctype === 'multiple') {
                        if (!this.state.edit || !col.editable) {
                            var options = [];
                            var currentValue = [];
                            var vals = this.state.data.get(col.source);
                            Object.keys(meta.values).map(function(i) {
                                options.push({value: i, label: meta.values[i]});
                                if (vals !== undefined && vals.indexOf(i) >= 0) {
                                    currentValue.push({value: i, label: meta.values[i]})
                                }
                            }, this);
                            return  (
                                <td key={index}>
                                    <Select
                                        name={col.source}
                                        options={options}
                                        selected={this.props.row[col.source]}
                                        id={col.source}
                                        isMulti
                                        isDisabled
                                        placeholder={col.label}
                                        value={currentValue}
                                        onChange={this.handleMultiSelectChange.bind(this, col.source)}
                                    />
                                </td>
                            )
                        } else {
                            //TODO: fix valuesif cases
                            var options = [];
                            var currentValue = [];
                            var t = this.state.data.get(col.source);
                            var vals = this.state.data.get(col.source).split(",");
                            Object.keys(meta.values).map(function(i) {
                                options.push({value: i, label: meta.values[i]});
                                if (vals !== undefined && vals.indexOf(i) >= 0) {
                                    currentValue.push({value: i, label: meta.values[i]})
                                }
                            }, this);
                            return  (
                                <td key={index}>
                                    <Select
                                        name={col.source}
                                        options={options}
                                        selected={this.props.row[col.source]}
                                        id={col.source}
                                        isMulti
                                        placeholder={col.label}
                                        value={currentValue}
                                        onChange={this.handleMultiSelectChange.bind(this, col.source)}
                                    />
                                </td>
                            )
                        }
                    }
                    // CHECKBOXes
                    if (ctype === 'checkbox') {
                        if (!this.state.edit || !col.editable) {
                            return(
                                <td key={ index }>
                                    <Checkbox
                                        label=''
                                        checked={ this.state.data.get(col.source) }
                                        placeholder={ col.label }
                                        className="form-control"
                                        disabled = {true}
                                        noForm
                                    />
                                </td>
                            )
                        } else {
                            return (
                                <td key={ index }>
                                    <Checkbox
                                        label=''
                                        checked={ this.state.data.get(col.source) }
                                        placeholder={ col.label }
                                        onChange={ this.handleChange.bind(this, col.source) }
                                        className="form-control"
                                        disabled = {false}
                                        noForm
                                    />
                                </td>
                            )
                        }
                    }
                    // URLs (not editable AFAIK
                    if (ctype === 'link') {
                        var url = col.value;
                        url = url.replace('{$id}', pk);
                        return <td key={ index }><Link to={url} className="btn btn-info btn-xs">
                            <i className="material-icons" style={{verticalAlign: 'middle', marginRight: '8px'}}>visibility</i>
                            <span style={{verticalAlign: 'middle'}}>{col.label}</span>
                        </Link></td>
                    }
                    // datetime
                    if (ctype === "datetime") {
                        var dd = new Date(this.state.data.get(col.source));
                        if (!this.state.edit || !col.editable) {
                            return <td key={index}>{dd.toDateString()}</td>
                        } else {
                            return <td key={index}>
                                <DatePicker
                                    selected={ dd }
                                    onChange={ this.handleDateChange.bind(this, col.source) }
                                /></td>
                        }
                    }
                    // datetimefull
                    if (ctype === "datetimefull") {
                        var dd = new Date(this.state.data.get(col.source));
                        const utcTime = zonedTimeToUtc(new Date(this.state.data.get(col.source)),"UTC");
                        if (!this.state.edit || !col.editable) {
                            try {
                                return <td key={index}>{utcTime.toLocaleString(prefs.locale,{timeZoneName:'short', timeZone: prefs.tz})}</td>
                            } catch (err) {
                                return <td key={index}>{this.state.data.get(col.source)}</td>
                            }
                        } else {
                            return <td key={index}>
                                <DatePicker
                                    selected={ dd }
                                    onChange={ this.handleDateChange.bind(this, col.source) }
                                /></td>
                        }
                    }
                    // icon (non editable)
                    if (ctype === "icon") {
                        return <td key={index}>
                            <div className= { cx('label','label-info','lb-sm', col.classnames[this.props.row[col.source]] )}>{this.state.data.get(col.source)}</div>
                        </td>

                    }
                    // Password fields
                    if (ctype === 'password') {
                        if (!this.state.edit || !col.editable) {
                            return <td key={index}>********</td>
                        } else {
                            return (
                                <td key={index}>
                                    <TextField
                                        label=''
                                        type='text'
                                        value={ this.state.data.get(col.source) }
                                        placeholder={ col.placeholder === '' ? col.label : col.placeholder }
                                        onChange={ this.handleChange.bind(this, col.source) }
                                        className="form-control"
                                    /></td>)
                        }
                    }
                    // text/email fields
                    if (ctype === 'text' || ctype === 'email' || ctype === 'money') {
                        var value = this.state.data.get(col.source);
                        if (ctype === 'money') {
                            value = parseFloat(value).toFixed(2);
                        }
                        if (!this.state.edit || !col.editable) {
                            return <td key={index}>{ value }</td>
                        } else {
                            return (
                                <td key={index}>
                                    <TextField
                                        label=''
                                        type='text'
                                        value={ value }
                                        placeholder={ col.placeholder === '' ? col.label : col.placeholder }
                                        onChange={ this.handleChange.bind(this, col.source) }
                                        className="form-control"
                                    /></td>)
                        }
                    }
                }, this)}
                <td style={{"display":"none"}}><ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    closeOnClick={true}
                    pauseOnHover={true}
                    draggable={true}
                    progress="undefined"
                /></td>
            </tr>
        );
    }

}

class TableFoot extends React.Component {
    onPageChange(i) {
        this.props.onPageChange(i)
    }
    render() {
        var cols = this.props.columns.length;
        var start = (this.props.pagenum -1) * this.props.rowsperpage + 1;
        var end = Math.min((this.props.pagenum) * this.props.rowsperpage, this.props.datalen);
        return (
            <tfoot>
            { this.props.pagination &&
                <tr>
                    <td colSpan={cols}>
                        <div className="results-conter pull-left">
                            Showing { start } to { end } of {this.props.datalen} entries</div>
                        <div className="paginator pull-right">
                            <Paginator
                                pagenum={ this.props.pagenum }
                                datalen={ this.props.datalen }
                                rowsperpage={ this.props.rowsperpage }
                                onPageChange={ this.onPageChange.bind(this) }
                            />
                        </div>
                    </td>
                </tr>
            }
            </tfoot>
        );
    }
}

class Paginator extends React.Component {

    handlePage(i, e) {
        e.preventDefault();
        var numpages = Math.ceil( this.props.datalen / this.props.rowsperpage );
        if (i < 1)
            i = 1;
        if (i > numpages)
            i = numpages;
        this.props.onPageChange(i);
    }

    render() {
        var pages  =[];
        var numpages = Math.ceil( this.props.datalen / this.props.rowsperpage );
        for (var i = 0 ; i < numpages; i++) {
            pages.push(
                <li key={i} className={cx("page-item",i === this.props.pagenum-1 ? "active" : "")}>
                    <a className="page-link" href="#" onClick={this.handlePage.bind(this,i+1)}>{i+1}</a>
                </li>
            )
        }
        return (
            <ul className="pagination">
                <li className={cx("page-item",  this.props.pagenum===1 ? "disabled" : "")}>
                    <a
                        className={cx("page-link",  this.props.pagenum===1 ? "disabled" : "")}
                        href="#"
                        onClick={this.handlePage.bind(this,this.props.pagenum-1)}>
                        Previous
                    </a></li>
                { pages }
                <li className={cx("page-item",  this.props.pagenum===numpages ? "disabled" : "")}>
                    <a
                        className={cx("page-link",  this.props.pagenum===numpages ? "disabled" : "")}
                        href="#"
                        onClick={this.handlePage.bind(this,this.props.pagenum+1)}>
                        Next
                    </a></li>
            </ul>
        );
    }
}

class TableBody extends React.Component {
    constructor () {
        super()
        this.state = {
            data: {data: []},
            metadata: [],
            idcol: null,
            pagenum: 1
        }
    }

    onRemove(val){        
        var newdata = this.state.data;
        let idx;
        newdata.data.map(function(nrow, i) {
             if (nrow[this.state.idcol] === val) {
                 idx = i;                
             }
        }, this);
        newdata.data.splice(idx,1)
        this.setState({
            data: newdata
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            data: nextProps.data
        })

    }

    componentDidMount() {
        var idcol = null;
        this.props.metadata.map(function(col, index) {

            if (col.type === 'primary') {
                idcol = col.source;
            }
        }, this);

        this.setState({
            idcol: idcol
        })
    }

    onPageChange(i) {
        this.setState({pagenum: i})
    }

    render() {
        var datalen = this.state.data.data.length;
        var rows = [];
        var pagenum = this.state.pagenum;
        var rowsperpage = this.props.rowsperpage;
        if (!this.props.pagination) {
            rowsperpage = datalen;
        }

        for (var i = (pagenum - 1) * rowsperpage ; i < (pagenum - 1) * rowsperpage + rowsperpage; i++) {
            var datarow = this.state.data.data[i];
            if (datarow === undefined)
                break;
            var id = datarow[this.state.idcol];
            rows.push(
                <TableRow
                    key={id}
                    id={id}
                    row={datarow}
                    metadata={this.props.metadata}
                    remotemeta = {this.props.data.metadata}
                    url = {this.props.url}
                    urlattrs={this.props.urlattrs}
                    onDelete={this.onRemove.bind(this)}
                    prefs={this.props.prefs}
                    {...this.props}
                />);
        }
        return (
            <div>
                <table className={ cx(this.props.className || 'table mb-0') }  >
                    <TableHead
                        columns={this.props.metadata}
                        pagenum={this.state.pagenum}
                        datalen = { datalen }
                        rowsperpage = { rowsperpage }
                        onPageChange = { this.onPageChange.bind(this) }
                        pagination = { this.props.pagination }
                    />
                    <tbody>

                    { rows }
                    {  this.props.loading &&
                    <tr className="loader-animation"/>
                    }
                    </tbody>
                    <TableFoot
                        columns={this.props.metadata}
                        pagenum={this.state.pagenum}
                        datalen = { datalen }
                        rowsperpage = { rowsperpage }
                        onPageChange = { this.onPageChange.bind(this) }
                        pagination = { this.props.pagination }
                    />
                </table>
            </div>
        );
    }
};



class Filter extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            data: imm.Map(),
            loading: true
        }
    }

    componentWillMount() {
        this.loadDefaults();
    }

    loadDefaults() {
        if (this.props.userfilter === undefined)
            return;

        this.props.userfilter.map(function (row, i) {
            if (row.type === 'date_range') {
                var src1 = row.source + '_from';
                var src2 = row.source + '_to';
                var val1 = moment(row.default.from).set({'hour': 0, 'minute': 0, 'second': 0}).toISOString(true);
                var val2 = moment(row.default.from).set({'hour': 23, 'minute': 59, 'second': 59}).toISOString(true);
                this.setState((state) => ({
                    data: state.data.set(src1, val1).set(src2, val2)
                }))
            } else if (row.type === 'select') {

            } else {
                if (row.default !== undefined) {
                    this.setState((state) => ({
                        data: state.data.set(row.source, row.default)
                    }))
                }
            }
        }, this);
    }

    handleChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }));
    }
    handleDateChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value.format())
        }));
    }
    handleDateRangeFromChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }))
    }
    handleDateRangeToChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }))
    }
    handleSelectChange(key, value) {
        if (value === null) {
            return;
        }
        var val = value.value;
        this.setState((state) => ({
            data: state.data.set(key, val)
        }));
    }
    componentWillReceiveProps() {
        this.setState({loading: false})
    }

    handleFilter() {
        this.setState({loading: true},this.props.onFilter(this.state.data));
    }
    handleClear() {
        this.loadDefaults();
    }
    render() {
        if (this.props.userfilter === undefined)
            return null;
        if (this.props.userfilter.length === 0)
            return null;
        let csv_link = config.apiGateway.URL + this.props.url;
        if (this.props.urlattrs !== undefined) {
            for (var key in this.props.urlattrs) {
                var repl = '{$' + key + '}';
                csv_link = csv_link.replace(repl, this.props.urlattrs[key]);
            }
        }
        csv_link = csv_link + '?export=1&method=get';
        this.props.userfilter.map(function (row, i) {
            if (row.type === 'date_range') {
                csv_link = csv_link + '&' + row.source + '_from=' + this.state.data.get(row.source + '_from') + '&' + row.source + '_to=' + this.state.data.get(row.source + '_to') ;
            } else {
                csv_link = csv_link + '&' + row.source + '=' + this.state.data.get(row.source);
            }
        }, this);

        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <div className="panel-title">
                        Filter
                    </div>
                </div>
                <div className="panel-body">
                    <form className="form-vertical">
                        <div className="row">
                            <div className="col-lg-12">
                            {
                                this.props.userfilter.map(function (row, i) {
                                    // condition check
                                    var src = row.source;
                                    if (row.type === 'text') {
                                        return (
                                            <div key={i} className="form-group">
                                                <label
                                                    className="col-sm-2 control-label"
                                                    htmlFor={src}>{row.label}</label>
                                                <div className="col-sm-2 input-group">
                                                    <TextField
                                                        label=''
                                                        type='text'
                                                        value={this.state.data.get(src)}
                                                        onChange={this.handleChange.bind(this, src)}
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                        );
                                    } else if (row.type === 'select') {
                                        var meta = this.props.data.metadata[src];
                                        var options = [];
                                        if (row.options !== undefined) {
                                            if (row.options.empty) {
                                                var options = [{value: 0, label: '--'}];
                                            }
                                        }

                                        var defaultSelect = {value: 0, label: '--'};
                                        if (meta !== undefined) {
                                            Object.keys(meta.values).map(function (i) {
                                                options.push({value: i, label: meta.values[i]});
                                                if (i === this.state.data.get(src)) {
                                                    defaultSelect = {value: i, label: meta.values[i]}
                                                }
                                            }, this);
                                        }
                                        return (
                                            <div key={i} className="form-group">
                                                <label
                                                    className="col-sm-2 control-label"
                                                    htmlFor={src}>{row.label}</label>
                                                <div className="col-sm-2 input-group">
                                                    <Select
                                                        name={src}
                                                        options={options}
                                                        selected={this.state.data.get(src)}
                                                        id={src}
                                                        placeholder={row.label}
                                                        value={defaultSelect}
                                                        onChange={this.handleSelectChange.bind(this, src)}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    } else if (row.type === 'date_range') {
                                        var d1 = new Date(this.state.data.get(src + '_from'));
                                        var d2 = new Date(this.state.data.get(src +'_to'));
                                        var opt_date_only = false;
                                        if (row.options !== undefined && row.options.includes("date_only")) {
                                            opt_date_only = true;
                                        }
                                        return (
                                            <div key = {i} className="form-group">
                                                <label
                                                    className="col-sm-2 control-label"
                                                    htmlFor={src}>{row.label} from</label>
                                                <div className="col-sm-4 input-group">
                                                    <DatePicker
                                                        className="form-control datepicker"
                                                        selected={ d1 }
                                                        onChange={ this.handleDateRangeFromChange.bind(this, src + '_from') }
                                                        showTimeSelect={!opt_date_only}
                                                        timeFormat="HH:mm"
                                                        dateFormat={opt_date_only ? "yyyy-MM-dd" : "yyyy-MM-dd HH:mm"}
                                                    />
                                                </div>
                                                <div
                                                    className="col-sm-2">to
                                                </div>
                                                <div className="col-sm-4 input-group">
                                                    <DatePicker
                                                        className="form-control datepicker"
                                                        selected={ d2 }
                                                        onChange={ this.handleDateRangeToChange.bind(this, src + '_to') }
                                                        showTimeSelect={!opt_date_only}
                                                        timeFormat="HH:mm"
                                                        dateFormat={opt_date_only ? "yyyy-MM-dd" : "yyyy-MM-dd HH:mm"}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }
                                }, this)
                            }

                            </div>
                        </div>
                    </form>
                </div>
                <div className="panel-footer">
                    <Button bsStyle="save" disabled={this.props.loading} value="Filter" onClick={this.handleFilter.bind(this)}/>
                    <Button bsStyle="cancel" disabled={this.props.loading} value="Reset" onClick={this.handleClear.bind(this)}/>
                    { this.props.download &&
                    <div
                        type="button"
                        className="btn btn-download pull-right"
                    ><a className="a-btn-download" href={ csv_link }>Export CSV</a></div>
                    }
                </div>
            </div>
        )
    }
}

export default class EdiTable extends React.Component {
    render(){
        let prefs = {};
        if (this.props.childProps.prefs !== undefined) {
            prefs = this.props.childProps.prefs;
        }

        return (
            <div className="card">
                <div className="row">
                    <div className="col-lg-12">

                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                    <Filter
                        userfilter = {this.props.userfilter}
                        onFilter = { this.props.onFilter }
                        loading = { this.props.loading }
                        url = { this.props.url }
                        urlattrs = { this.props.urlattrs }
                        download = { this.props.download }
                        data={this.props.data}
                        metadata={this.props.metadata}
                        prefs = {prefs}
                    />
                    </div>
                </div>
                <div className="row card-body p-0 pb-3 text-center">
                    <div className="col-lg-12">
                        <TableBody
                            data={this.props.data}
                            metadata={this.props.metadata}
                            url={this.props.url}
                            urlattrs={this.props.urlattrs}
                            className={ this.props.className }
                            rowsperpage = { this.props.rowsperpage || 100}
                            loading = { this.props.loading }
                            pagination = { this.props.pagination }
                            prefs = {prefs}
                            {...this.props}
                        />
                    </div>
                </div>
            </div>
        );
    }
};

